import * as R from 'ramda';

export const sum = R.pipe(R.filter(Boolean), R.sum);
